import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "14",
  fill: "none",
  viewBox: "0 0 16 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.661 6.374a1.72 1.72 0 0 0-1.367-.655H14V4.454c0-1.754-1.495-3.182-3.333-3.182h-3.37a.7.7 0 0 1-.298-.067L4.894.201A2.1 2.1 0 0 0 4 0H2.667C1.196 0 0 1.141 0 2.545v8.273C0 12.573 1.495 14 3.333 14h8.372c1.483 0 2.766-.911 3.2-2.296l1.022-3.892a1.55 1.55 0 0 0-.266-1.438M1.333 10.818V2.545c0-.702.598-1.273 1.334-1.273H4c.102 0 .206.024.298.067L6.4 2.343c.276.132.585.201.895.201h3.37c1.103 0 2 .857 2 1.91v1.264H5.743c-1.133 0-2.145.687-2.526 1.731l-1.46 4.543a1.85 1.85 0 0 1-.424-1.174m13.309-3.343-1.021 3.892c-.257.814-1.026 1.36-1.916 1.36H3.333q-.208 0-.405-.04l1.556-4.842c.186-.51.693-.854 1.26-.854h8.551c.161 0 .255.09.297.143s.104.165.05.341"
    }, null, -1)
  ]))]))
}
export default { render: render }